import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewsCategoryService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  getAll(langCode = ''): Observable<any> {
    if (!langCode) {
      return this.http.get(`${this.apiUrl}CategoryGetAll`);
    }

    return this.http.get(`${this.apiUrl}CategoryGetAll?lang=${langCode}`);
  }

  getById(id: number, langCode = ''): Observable<any> {
    if (!langCode) {
      return this.http.get(`${this.apiUrl}CategoryGetById/${id}`);
    }

    return this.http.get(`${this.apiUrl}CategoryGetById/${id}?lang=${langCode}`);
  }

  create(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}CreateCategory`, request);
  }

  update(id: number, request: any): Observable<any> {
    return this.http.put(`${this.apiUrl}UpdateCategory/${id}`, request);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}DeleteCategory/${id}`);
  }
}
